'use strict';

angular.module('ecrd.core')
    .provider('CoreRecordData', function() {
        this.$get = ['CoreRecord', function CoreRecordData(CoreRecord) {
            return CoreRecord.getData();
        }];
    });
